import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { Component, Input } from '@angular/core';
import { ListingStatusEnum } from 'shared/constants/listing-statuses';

@Component({
    selector: 'app-listing-status-filter',
    templateUrl: './listing-status-renderer.component.html',
    styleUrls: ['./listing-status-renderer.component.scss'],
    standalone: false,
})
export class ListingStatusRendererComponent implements ICellRendererAngularComp {
    @Input() set parentFilterValue(value: string) {
        this._parentFilterValue = value ?? 'selectAll';
    }

    get parentFilterValue(): string {
        return this._parentFilterValue;
    }

    @Input() isFloatingFilterIcon?: boolean = false;
    public listingStatusEnum = ListingStatusEnum;
    protected isNewListing: boolean = false;
    private _parentFilterValue: string = '';

    agInit(params: ICellRendererParams & { isFloatingFilterIcon?: boolean }): void {
        this.isFloatingFilterIcon = Boolean(params.isFloatingFilterIcon);
        this.parentFilterValue = Object.values(ListingStatusEnum)[Object.values(ListingStatusEnum).indexOf(params.value)];

        if (params.data?.maxVersion === 1 && params.value !== ListingStatusEnum.LIVE) {
            this.isNewListing = true;
        }
    }

    refresh() {
        return false;
    }
}
